import React from 'react';
import { Link, Rating, Stack, Typography } from '@mui/material';

interface ReviewsInfoProps {
  googlePlaceInfo: {
    rating: number;
    reviewCount: number;
    mapsUrl: string;
  };
}

export const ReviewsInfo: React.FC<ReviewsInfoProps> = ({
  googlePlaceInfo,
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{ mt: 1, mb: 3 }}
    >
      <Typography variant="body1" sx={{ fontWeight: 400 }}>
        {googlePlaceInfo.rating}
      </Typography>
      <Rating
        value={googlePlaceInfo.rating}
        precision={0.1}
        readOnly
      />
      <Link
        href={googlePlaceInfo.mapsUrl}
        target="_blank"
        underline="hover"
        sx={{
          color: 'text.primary',
          textDecoration: 'none',
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 400 }}>
          {googlePlaceInfo.reviewCount} Google reviews
        </Typography>
      </Link>
    </Stack>
  );
};
